<!-- 轮播图 -->
<template>
  <div>
    <section id="swiperBox" class="d-flex align-items-center ptb-swiper">
      <div class="container">
        <div class="text-align-center arrow-box">
          <h1 class="title-main font-weight-bold pb-2">{{ title }}-项目展示</h1>
          <p class="title-sub pb-3">Product Display</p>
          <a :href="'#/home?maodian=case'" class="arrow">
            <img src="@/assets/img/common/case/left.png" class="image-width-100">
          </a>
        </div>
        
        <div class="row plf-swiper">
          <div class="swiper-slider-box swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in bannerList" :key="'swiper'+index">
                <img :src="item.src"  class="image-width-100" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.js'
export default {
  name: 'Swiper',
  components: {},
  props: {
    title: {
      type: String,
      default:''
    },
    bannerList: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
    
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {

  },
  mounted() {
    new Swiper('.swiper-slider-box', {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  },
}
</script>
<style scoped>
@media (max-width: 768px){
  .ptb-swiper{
    padding: 2rem 0;
  }
  .plf-swiper{
    padding: 0 3rem;
  }
  .arrow{
    width: 2.5rem;
  }
}
@media (min-width: 768px){
  .ptb-swiper{
    padding: 3rem 0;
  }
  .plf-swiper {
    padding: 0 15rem;
  }
  .arrow{
    width: 3.5rem;
  }
}
.arrow-box{
  position: relative;
}
.arrow{
  position: absolute;
  height: auto;
  top: 0;
  left: 0;
}
</style>